import L from 'leaflet'
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import { useEffect } from 'react'
import { lang } from '@src/lang'

export type Point = [number, number, number]

export interface MarkerData {
    lat: number
    lng: number
    info: {
        class_name: string
        area_px: number
        volume_m3: number
        mass_kg: number
    }
    icon?: L.DivIcon
}

interface HeatmapLayerProps {
    points: Point[]
}

interface Props {
    points: Point[]
    markers: MarkerData[]
}

const classColors: Record<number, string> = {
    1: '#FFFFFF', // железо - белый
    2: '#00FFFF', // рыболовные снасти - голубой
    3: '#00FF00', // пластик - зеленый
    4: '#FF0000', // дерево - красный
    5: '#FF00FF', // бетон - фиолетовый
    6: '#FFFF00', // резина - желтый
}

export const createColoredMarker = (classId: number): L.DivIcon => {
    const color = classColors[classId] || '#808080'
    return L.divIcon({
        className: 'custom-marker',
        html: `<div style="
      background-color: ${color};
      border: 2px solid #000;
      border-radius: 50%;
      width: 20px;
      height: 20px;
    "></div>`,
        iconSize: [20, 20],
        iconAnchor: [10, 10],
    })
}

const HeatmapLayer = ({ points }: HeatmapLayerProps) => {
    const map = useMap()

    useEffect(() => {
        if (!points.length) return

        const heatLayer = (L as any).heatLayer(points, { radius: 25 }).addTo(map)

        return () => {
            map.removeLayer(heatLayer)
        }
    }, [points, map])

    return null
}

export const MapComponent = (props: Props) => {
    return (
        <MapContainer center={[0, 0]} zoom={2}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <HeatmapLayer points={props.points} />
            {props.markers.map((marker, idx) => (
                <Marker key={idx} position={[marker.lat, marker.lng]} icon={marker.icon}>
                    <Popup>
                        <b>{marker.info.class_name}</b>
                        <br />
                        {lang.area}: {marker.info.area_px} px
                        <br />
                        {lang.volume}: {marker.info.volume_m3.toFixed(3)} m³
                        <br />
                        {lang.mass}: {marker.info.mass_kg.toFixed(2)} kg
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    )
}
